<template>
  <section>
    <div style="position: relative">
      <div
        v-if="isAdmin[0]"
        class="action-buttons"
      >
        <div
          v-if="!modifiedRows.length"
          class="button-add-campaign"
        >
          <button
            class="button is-success is-medium"
            id="clear"
            @click="$parent.isComponentModalActive = true"
          >
            <span><i class="fal fa-plus-circle"></i> Ajouter une Campagne</span>
          </button>
        </div>
        <div class="action-button">
          <button
            v-if="checkedRows.length"
            class="button field is-danger is-medium"
            id="clear"
            @click="deleteChecked"
            :disabled="!checkedRows.length"
          >
            <span>Supprimer</span>
          </button>
        </div>
        <!-- <div class="action-button">
          <button
            v-if="modifiedRows.length"
            class="button field is-green is-medium"
            id="clear"
            @click="validateModifications"
            :disabled="!modifiedRows.length"
          >
            <span><i class="fal fa-check"></i> Valider les modifications</span>
          </button>
        </div>
        <div class="action-button">
          <button
            v-if="modifiedRows.length"
            class="button field is-danger is-medium"
            id="clear"
            @click="cancelModifications"
            :disabled="!modifiedRows.length"
          >
            <span><i class="fal fa-times"></i> Annuler les modifications</span>
          </button>
        </div> -->
      </div>
    </div>

    <!-- ANCHOR TABLE -->
    <b-table
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :checked-rows.sync="checkedRows"
      :checkable="isAdmin[0]"
      :mobile-cards="false"
    >
      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >
          {{ props.column.label }}
        </b-tooltip>
      </template>

      <template slot-scope="props">
        <b-table-column
          meta="Nom de la campagne"
          field="name"
          label="Nom"
          :centered="true"
          :sortable="true"
        >
          <span class="tag is-primary is-medium">
            <input
              :disabled="!isAdmin[0]"
              class="b-ip-input"
              v-model="props.row.name"
              @input="toggleModified(props.row)"
              placeholder="Entrer un nom"
            >
          </span>
        </b-table-column>

        <b-table-column
          meta="Sous Campagnes optionnelles"
          field="sub_campaigns"
          label="Sous Campagnes"
          :centered="true"
          :sortable="true"
        >
          <span
            style="width: fit-content; margin: 2px;"
            v-for="(sub_campaign, index) in props.row.sub_campaigns"
            :key="index"
          >
            <button
              class="button is-danger is-small"
              id="clear"
              style="margin: 2px 0;"
              @click="clickRemoveSubCampaign(sub_campaign.id)"
            >
              <span><i class="fal fa-times-circle"></i> {{sub_campaign.name}}</span>
            </button>
          </span>
          <div>
            <button
              class="button is-success is-small"
              id="clear"
              @click="clickAddNewSubCampaign(props.row.id)"
            >
              <span><i class="fal fa-plus-circle"></i> Ajouter une sous-campagne</span>
            </button>
          </div>
        </b-table-column>

        <b-table-column
          meta="Date de début de la Campgane"
          field="start_date"
          label="Date de Début"
          :centered="true"
          :sortable="checkable"
        >
          <b-datepicker
            :disabled="!isAdmin[0]"
            class="b-date-picker"
            v-model="props.row.start_date"
            @input="toggleModified(props.row)"
            @click="this.$parent.scrollToBottom()"
            :first-day-of-week="1"
            :max-date="props.row.end_date"
            :month-names="['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre']"
            :day-names="['D', 'L', 'Ma', 'Me', 'J', 'V', 'S']"
            placeholder="Choisir Date"
          >
            <button
              class="button is-primary"
              @click="props.row.start_date = new Date()"
            >
              <span>Ajourd'hui</span>
            </button>
          </b-datepicker>
        </b-table-column>

        <b-table-column
          meta="Date de fin de la Campgane"
          field="end_date"
          label="Date de Fin"
          :centered="true"
          :sortable="checkable"
        >
          <b-datepicker
            :disabled="!isAdmin[0]"
            class="b-date-picker"
            v-model="props.row.end_date"
            @input="toggleModified(props.row)"
            :first-day-of-week="1"
            :month-names="['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre']"
            :day-names="['D', 'L', 'Ma', 'Me', 'J', 'V', 'S']"
            :min-date="props.row.start_date"
            placeholder="Choisir Date"
          >
            <button
              class="button is-primary"
              @click="props.row.end_date = new Date()"
            >
              <span>Ajourd'hui</span>
            </button>
          </b-datepicker>
        </b-table-column>

        <b-table-column
          meta="Nombre de ventes à atteindre avant la fin de la campagne"
          field="campaign_sales_goal"
          label="Objectif de Ventes"
          :sortable="checkable"
        >
          <b-input
            :disabled="!isAdmin[0]"
            class="b-input-number"
            type="number"
            min="0"
            oninput="this.value = Math.abs(this.value)"
            v-model="props.row.campaign_sales_goal"
            @input="toggleModified(props.row)"
            placeholder="Objectif"
          ></b-input>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas de Campagnes</p>
          </div>
        </section>
      </template>
    </b-table>

    <!-- ANCHOR MODALS -->
    <b-modal
      :active.sync="$parent.isComponentModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 750px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Ajouter une Campagne</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                label="Nom de Campagne :"
                required
              >
                <b-input
                  v-model="formName"
                  class="b-modal-text-input"
                  type="text"
                  placeholder="Entrer un Nom"
                ></b-input>
              </b-field>

              <b-field
                class="modal-input-field"
                label="Objectif de Vente :"
                required
              >
                <b-input
                  class="b-modal-input-number"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  v-model="formSalesGoal"
                  placeholder="Objectif"
                ></b-input>
              </b-field>
            </div>

            <div class="modal-line">
              <b-field
                label="Date de début"
                required
              >
                <b-datepicker
                  class="b-modal-date-picker"
                  v-model="formStartDate"
                  :first-day-of-week="1"
                  :month-names="['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre']"
                  :day-names="['D', 'L', 'Ma', 'Me', 'J', 'V', 'S']"
                  :max-date="formEndDate"
                  :inline="true"
                  placeholder="Choisir Date"
                >
                </b-datepicker>
              </b-field>

              <b-field
                label="Date de Fin"
                required
              >
                <b-datepicker
                  class="b-modal-date-picker"
                  v-model="formEndDate"
                  :first-day-of-week="1"
                  :month-names="['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre']"
                  :day-names="['D', 'L', 'Ma', 'Me', 'J', 'V', 'S']"
                  :min-date="formStartDate"
                  :inline="true"
                  placeholder="Choisir Date"
                >
                </b-datepicker>
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="submitFormData"
            ><span><i class="fal fa-check"></i> Ajouter</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :active.sync="$parent.isDeleteConfirmationModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 680px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Confirmer la suppression des Campagnes sélectionnées ?</p>
          </header>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="confirmDelete"
            ><span><i class="fal fa-check"></i> Confirmer</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :active.sync="$parent.isDeleteSubCampaignConfirmationModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 580px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Confirmer la suppression de la Sous-Campagne ?</p>
          </header>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="confirmDeleteSubCamapaign"
            ><span><i class="fal fa-check"></i> Confirmer</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :active.sync="$parent.isAddNewSubCampaignModalActive"
      has-modal-card
    >
      <form action="add-subcampaign">
        <div
          class="modal-card"
          style="width: 750px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Ajouter une Sous-campagne</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                label="Nom de la sous-campagne :"
                required
              >
                <b-input
                  v-model="formName"
                  class="b-modal-text-input"
                  type="text"
                  placeholder="Entrer un Nom"
                ></b-input>
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="submitAddSubCampaignFormData"
            ><span><i class="fal fa-check"></i> Ajouter</span></button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import _ from "lodash";

export default {
  name: "CampaignsTable",
  props: ["campaigns", "checkable", "supervisors", "isAdmin"],
  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      checkedRows: [],
      modifiedRows: [],
      myData: [],
      storedCampaigns: [],
      formSalesGoal: "",
      formName: "",
      formStartDate: new Date(),
      formEndDate: new Date()
    };
  },
  watch: {
    campaigns: function(newVal, oldVal) {
      // watch it
      this.myData = this.campaigns;
      this.storedCampaigns = JSON.parse(JSON.stringify(this.campaigns));
      this.isLoading = false;
    }
  },
  methods: {
    clickRemoveSubCampaign(id) {
      this.deletingSubCampaign = id;
      this.$parent.isDeleteSubCampaignConfirmationModalActive = true;
    },

    clickAddNewSubCampaign(id) {
      this.addSubCampaignToId = id;
      this.$parent.isAddNewSubCampaignModalActive = true;
    },
    resetMyData() {
      this.myData = [
        {
          id: "",
          name: "",
          start_date: null,
          end_date: null,
          daily_sales_goal: false
        }
      ];
      this.resetFormData();
    },
    deleteChecked() {
      this.$parent.isDeleteConfirmationModalActive = true;
    },
    confirmDelete() {
      this.$parent.deleteCheckedRows(this.checkedRows);
      this.checkedRows = [];
      setTimeout(() => {
        this.modifiedRows = [];
      }, 70);
    },
    confirmDeleteSubCamapaign() {
      this.$parent.deleteSubCampaign(this.deletingSubCampaign);
    },

    debounceModif: _.debounce(async function(e) {
      this.$parent.modifyRows(e);
    }, 500),

    toggleModified(raaw) {
      this.debounceModif([raaw]);
      // var modified = false;
      // this.modifiedRows.push(raaw);
      // for (var j = 0; j < this.modifiedRows.length; j++) {
      //   var row = this.modifiedRows[j];
      //   for (var i = 0; i < this.storedCampaigns.length; i++) {
      //     var campaign = this.storedCampaigns[i];
      //     if (campaign.id == row.id) {
      //       if (
      //         !(
      //           campaign.name == row.name &&
      //           campaign.start_date ==
      //             JSON.parse(JSON.stringify(row.start_date)) &&
      //           campaign.end_date == JSON.parse(JSON.stringify(row.end_date)) &&
      //           campaign.campaign_sales_goal == row.campaign_sales_goal
      //         )
      //       ) {
      //         modified = true;
      //       }
      //     }
      //   }
      //   if (!modified) {
      //     this.modifiedRows = [];
      //   }
      // }
    },
    // validateModifications() {
    //   this.$parent.modifyRows(this.modifiedRows);
    //   setTimeout(() => {
    //     this.modifiedRows = [];
    //     this.checkedRows = [];
    //     this.storedCampaigns = JSON.parse(JSON.stringify(this.campaigns));
    //   }, 70);
    // },
    cancelModifications() {
      if (this.isAdmin[0]) {
        this.$parent.getCampaigns();
      } else {
        this.resetMyData();
      }
      this.$parent.hideAdd();

      setTimeout(() => {
        this.modifiedRows = [];
        this.checkedRows = [];
      }, 100);
    },
    submitFormData() {
      if (
        this.formSalesGoal == "" ||
        this.formName == "" ||
        this.formStartDate == "" ||
        this.formEndDate == ""
      ) {
        this.$parent.errorToast("Merci de remplir tous les champs");
      } else {
        this.$parent.addNewRow({
          campaign_sales_goal: this.formSalesGoal,
          start_date: this.formStartDate,
          end_date: this.formEndDate,
          name: this.formName
        });
        setTimeout(() => {
          this.storedCampaigns = JSON.parse(JSON.stringify(this.campaigns));
          this.modifiedRows = [];
          this.checkedRows = [];
          this.resetMyData;
        }, 70);
      }
    },
    submitAddSubCampaignFormData() {
      if (this.formName == "") {
        this.$parent.errorToast("Merci de saisir un nom");
      } else {
        this.$parent.addNewSubCampaign({
          campaign_id: this.addSubCampaignToId,
          name: this.formName
        });
        setTimeout(() => {
          this.storedCampaigns = JSON.parse(JSON.stringify(this.campaigns));
          this.modifiedRows = [];
          this.checkedRows = [];
          this.resetMyData;
        }, 70);
      }
    },
    dismissForm() {
      this.$parent.isDeleteConfirmationModalActive = false;
      this.$parent.isAddNewSubCampaignModalActive = false;
      this.$parent.isComponentModalActive = false;
      this.resetFormData();
    },
    resetFormData() {
      (this.formSalesGoal = ""),
        (this.formName = ""),
        (this.formStartDate = new Date()),
        (this.formEndDate = new Date());
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 768px) {
  .action-buttons,
  .action-button {
    float: unset;
  }

  .b-table {
    margin-top: 2em;
  }
}

.b-input-number {
  width: 90px;
  margin-left: 15px;
}

.b-date-picker {
  width: 200px;
  text-align: center;
  display: inline-block;
}

.b-modal-date-picker {
  width: 350px;
  text-align: center;
  display: inline-block;
}

.b-ip-input {
  /* width: 130px; */
  text-align: center;
  border-color: transparent !important;
  background-color: transparent;
  color: #fff;
  outline: 0px !important;
  font-size: 1em;
}

::placeholder {
  color: #ddd;
}

.modal-line {
  display: flex;
  justify-content: space-between;
}

.modal-input-field {
  width: -webkit-fill-available;
  padding-left: 150px;
}

.b-modal-input-number {
  padding-left: 10px;
  width: 100px;
}

.b-modal-text-input {
  padding-left: 10px;
  width: 210px;
  text-align: center;
  background-color: transparent;
  color: #000;
  outline: 1px !important;
  font-size: 1em;
}
</style>